import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder, AbstractControl} from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {DtoEventAction} from "../../shared/models/DtoEventAction";
import {SettingsEventActionService} from "./settings-eventaction.service";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";

@Component({
    selector: 'eventaction',
    template: require('./eventaction.component.html'),
    styles: [require('./eventaction.component.css')]
})
@AutoUnsubscribe()

export class EventActionComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() typeId: number;
    @Input() id: number;
    @Input() header: string;
    @Input() subheader: string;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoEventAction;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsEventActionService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            actionIndex: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]]
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getEventActionById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getEventActionNextIndex(this.typeId)
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        actionIndex: res,
                        actionType: this.typeId
                    };
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkEventActionIndexAvailable(this.typeId, this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveEventAction(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-eventaction/eventaction.component.ts